@if (item) {
  <div class="structure-item">
    @if (item.parents) {
      <div class="parent">
        @for (parent of item.parents; track parent) {
          <app-sankey-chart-config-item
            [item]="parent"
            [parent]="item"
            [isSource]="true"
            (editItem)="editItem.emit($event)"
            (addItem)="addItem.emit($event)"
            (addSeries)="addSeries.emit($event)"
            (removeItem)="removeItem.emit(Object.assign($event, { prop: 'parents' }))"
            (removeSeries)="removeSeries.emit($event)"
          ></app-sankey-chart-config-item>
        }
        <button
          (click)="addItemToParents.emit(item)"
          mat-mini-fab
          class="primary-fab add-item-button"
          [matTooltip]="'BUTTON.ADD' | translate"
        >
          <mat-icon svgIcon="add"></mat-icon>
        </button>
      </div>
    }
    <div class="item">
      <div class="buttons">
        @if (!isRoot) {
          <button
            mat-mini-fab
            class="primary-fab action-button"
            (click)="showSeries()"
            [matTooltip]="'BUTTON.EDIT' | translate"
          >
            <mat-icon svgIcon="edit"></mat-icon>
          </button>
        }
        @if (parent && !isRoot) {
          <button
            mat-mini-fab
            class="warn-fab action-button"
            (click)="removeItem.emit({ parent, item, prop: 'children' })"
            [matTooltip]="'BUTTON.DELETE' | translate"
          >
            <mat-icon svgIcon="delete"></mat-icon>
          </button>
        }
      </div>
      <span class="name">{{ item.item_name | translate }}</span>
    </div>
    @if (seriesVisible) {
      <app-sankey-chart-config-series
        [item]="item"
        (addSeries)="addSeries.emit($event)"
        (editItem)="editItem.emit($event)"
        (hideSeries)="hideSeries()"
        (removeSeries)="removeSeries.emit($event)"
      ></app-sankey-chart-config-series>
    }
    <div class="children">
      @if (item.children && item.children.length > 0) {
        @for (child of item.children; track child) {
          <app-sankey-chart-config-item
            [item]="child"
            [parent]="item"
            (editItem)="editItem.emit($event)"
            (addItem)="addItem.emit($event)"
            (addSeries)="addSeries.emit($event)"
            (removeItem)="removeItem.emit($event)"
            (removeSeries)="removeSeries.emit($event)"
          ></app-sankey-chart-config-item>
        }
      }
      @if (!isSource) {
        <button
          (click)="addItem.emit(item)"
          mat-mini-fab
          class="primary-fab add-item-button"
          [matTooltip]="'BUTTON.ADD' | translate"
        >
          <mat-icon svgIcon="add"></mat-icon>
        </button>
      }
    </div>
  </div>
}
